<div class="min-h-screen bg-white flex flex-col">
  <div class="flex-1 container mx-auto max-w-[900px] px-5 py-12">
    <h1 class="text-3xl font-semibold text-gray-800 mb-8">Privacy Policy</h1>

    <div class="prose prose-gray max-w-none">
      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Introduction</h2>
        <p class="text-gray-600 mb-4">
          Vertical Bridge REIT, LLC commits to respecting privacy for all Site users. This policy covers information gathering practices for personal data provided through our website and web-based services.
        </p>
        <p class="text-gray-600 mb-4">
          In order to browse the public portions of the Site, you are not required to provide any personally identifiable information.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Information Collection</h2>

        <h3 class="text-lg font-medium text-gray-700 mb-3">User-Provided Data</h3>
        <p class="text-gray-600 mb-4">
          We may collect contact information, legal name, company affiliation, title, address, phone, and email for registration and service inquiries.
        </p>

        <h3 class="text-lg font-medium text-gray-700 mb-3">Cookies</h3>
        <p class="text-gray-600 mb-4">
          We use cookies for user experience, tracking site usage, storing preferences, and monitoring search patterns.
        </p>

        <h3 class="text-lg font-medium text-gray-700 mb-3">Automatic Collection</h3>
        <p class="text-gray-600 mb-4">
          Server logs capture IP addresses, browser type, device information, request timestamps, and interaction data.
        </p>

        <h3 class="text-lg font-medium text-gray-700 mb-3">Communications</h3>
        <p class="text-gray-600 mb-4">
          We retain emails and inquiries for processing requests and service improvement.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Data Usage & Sharing</h2>
        <p class="text-gray-600 mb-4">We may use your information for:</p>
        <ul class="list-disc list-inside text-gray-600 mb-4 space-y-2">
          <li>Fulfilling information requests</li>
          <li>Promoting services and properties</li>
          <li>Site administration and customization</li>
          <li>Third-party service providers operating under strict limitations</li>
          <li>Legal compliance and fraud prevention</li>
          <li>Aggregate, non-identifiable analysis</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Special Provisions</h2>
        <p class="text-gray-600 mb-4">
          The company may transfer information during corporate events, mergers, or acquisitions. Security measures are implemented but absolute protection cannot be guaranteed.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">User Rights</h2>
        <p class="text-gray-600 mb-4">
          Individuals may request updates or deletion of provided information, subject to practicality determinations.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Additional Disclosures</h2>
        <ul class="list-disc list-inside text-gray-600 mb-4 space-y-2">
          <li>Social media content follows those platforms' policies</li>
          <li>Third-party links operate under separate privacy standards</li>
          <li>U.S.-based servers process all data</li>
          <li>No tracking after leaving the Site</li>
          <li>Children's information is not knowingly collected</li>
        </ul>
      </section>
    </div>

    <div class="mt-12 pt-8 border-t border-gray-200">
      <a routerLink="/home" class="text-[#8BC540] hover:underline">&larr; Back to Home</a>
    </div>
  </div>

  <app-footer />
</div>
